module.exports = __webpack_public_path__ + "img/excel-file.0c6a64b9.svg";